/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_ShareInputs */

const en_rd_share = /** @type {(inputs: Rd_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy share link`)
};

const id_rd_share = /** @type {(inputs: Rd_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin tautan`)
};

/**
* | output |
* | --- |
* | "Copy share link" |
*
* @param {Rd_ShareInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_share = /** @type {((inputs?: Rd_ShareInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_ShareInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_share(inputs)
	return en_rd_share(inputs)
});